// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --chart-height: 400px;
}

.chart-wrapper {
  opacity: 0;
  animation: fadeIn 1s ease-in-out forwards;
}

highcharts-chart {
  width: 100%;
  height: var(--chart-height);
  display: block;
}

.date-range,
.country-selector {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}
.date-range__single,
.country-selector__single {
  font-size: 0.8rem;
  padding: 2px 1em;
  background: #fff;
  border-right: 1px solid #eee;
  cursor: pointer;
}
.date-range__single.active,
.country-selector__single.active {
  background: #f8f8f8;
}
.date-range__single:first-of-type,
.country-selector__single:first-of-type {
  border-radius: 5px 0 0 5px;
}
.date-range__single:last-of-type,
.country-selector__single:last-of-type {
  border-radius: 0 5px 5px 0;
  border: none;
}

.spacer {
  height: 30px;
}

.placeholder {
  width: 100%;
  height: 400px;
  margin-top: 30px;
  border: 5px dashed #fff;
  border-radius: 5px;
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
